import React from "react";
import "./Hero.scss";

export default function Hero() {
  return (
    <div className="hero-section" id="main">
      <div className="hero-introduction">
        <h1>
          <span className="slide-right sologan-p1">Macca </span> <br />
          <span className="slide-down sologan-p2">vạn phúc</span> <br />
          <span className="slide-right sologan-p3">trao trọn</span> <br />
          <span className="slide-right sologan-p4">cảm xúc </span> <br />
          <span className="slide-down sologan-p5">yêu </span> <br />
          <span className="slide-down sologan-p6">thương</span>
        </h1>
      </div>
    </div>
  );
}
